<ng-container [ngSwitch]="toolType$ | async">
  <mg-st-flex-time *ngSwitchCase="'student'"></mg-st-flex-time>
</ng-container>
